import Container from "@/components/common/Container";
import Title from "@/components/common/Title";

import {
  MOBILE_APP_ACCORDION_DATA,
  MOBILE_APP_TAB_DATA,
} from "const/data-solution";
import DataSolutionInnerTab from "../common/DataSolutionInnerTab";

const MobileAppTab = () => (
  <Container large className="pt-20 md:pt-40">
    <Title
      description="Experience tailored precision with our <b>Mobile App Scraping Services,</b> uniquely designed to cater to the specific demands of every industry. Elevate your data insights with customized solutions that align seamlessly with diverse sector requirements."
      descriptionClass="text-primary-black text-center mb-0 font-normal text-sm md:text-base font-light md:px-64 pb-10 md:pb-24"
      subTitle="Customized Solutions: Mobile App Scraping Services for Every Industry Need"
      subTitleClass="text-4xl md:text-6xl text-primary-black md:pb-6 md:mb-2 mb-4 text-center font-medium"
    />
    <DataSolutionInnerTab
      accordionData={MOBILE_APP_ACCORDION_DATA}
      data={MOBILE_APP_TAB_DATA}
    />
  </Container>
);

export default MobileAppTab;
